import React, { useEffect, useState } from "react";
import {
  CommonHeader,
  Loader,
  ErrorSuccessModal,
  RadioContainer,
  DropDown,
} from "../../../components/commons";
import { useLocation } from "react-router-dom";
import { connect } from "react-redux";
import { RootState } from "../../../redux/rootReducers";

import {
  BulkUploadError,
  BulkUploadSuccess,
  DownloadIcon,
  ReloadIcon,
} from "../../../components/Icon";
import { resetSession } from "../../../redux/auth";
import FileSaver from "file-saver";
import DraggableUpload from "../../../components/commons/Upload/DraggableUpload";
import toast, { Toaster } from "react-hot-toast";
import {
  getAllMappedClientColumnListAction,
  getBulkUploadHistoryAction,
  invoiceGenerationBulkUploadAction,
  invoiceGenerationExpensesBulkUploadAction,
  invoiceGenerationRevenuesBulkUploadAction,
  invoiceGenerationSuspenseBulkUploadAction,
  resetBulkUploadData,
  resetBulkUploadHistoryCount,
  resetBulkUploadHistoryData,
  resetInvoiceStatusCode,
  resetInvoicingError,
  resetInvoicingSuccess,
  resetMappedExpensesColumnList,
  resetMappedRevenueColumnList,
} from "../../../redux/invoiceGeneration";
import "./invoiceBulkUpload.scss";
import {
  BulkUploadHistoryDataType,
  InvoiceGenerationCategoryType,
  SingleMappedColumnType,
} from "../../../redux/invoiceGeneration/invoiceGenrationTypes";
import BulkUploadHistoryModal from "../../../components/InvoiceGeneration/BulkUploadHistory/BulkUploadHistoryModal";
import { GetBulkUploadHistoryPayloadType } from "../../../commonTypes/invoiceGenerationTypes";
import { useMenuCheck } from "../../../customHooks/useMenuCheck";
import { RadioTypes } from "../../../commonTypes/universalTypes";
import {
  getAllBusinessAddressAction,
  getAllTypesWithTaxListAction,
  resetAllLedgersList,
  resetBusinessAddressList,
} from "../../../redux/clientSettings";
import {
  GetAllBussinessAddressesListPayloadType,
  GetAllLedgersListPayloadType,
} from "../../../commonTypes/clientSettingsTypes";
import {
  AllLedgersListType,
  BusinessAddressListType,
} from "../../../redux/clientSettings/clientSettingTypes";

const blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
const blobToken = process.env.REACT_APP_BLOB_TOEKN;

interface Props {
  history: any;
  token: string | null;
  dispatchInvoiceBulkUploadAction: Function;
  dispatchInvoiceGenerationSuspenseBulkUploadAction: Function;
  dispatchInvoiceRevenuesBulkUploadAction: Function;
  dispatchInvoiceExpensesBulkUploadAction: Function;
  bulkUploadData: any | null;
  fetching: boolean;
  success: number | null;
  error: string | null;
  statusCode: number | null;
  dispatchResetSession: () => void;
  dispatchResetInvoiceStatusCode: () => void;
  dispatchResetInvoicingError: Function;
  dispatchResetInvoicingSuccess: () => void;
  dispatchResetBulkUploadData: Function;
  dispatchGetClientColumnListAction: Function;
  mappedRevenueColumnsList: InvoiceGenerationCategoryType;
  mappedExpensesColumnsList: InvoiceGenerationCategoryType;
  dispatchResetMappedRevenueColumnListAction: () => void;
  dispatchResetMappedExpensesColumnsListAction: () => void;
  dispatchGetBulkUploadHistoryData: (
    data: GetBulkUploadHistoryPayloadType
  ) => void;
  dispatchResetBulkUploadHistoryCount: () => void;
  message: null | string;
  bulkUploadHistoryCount: string;
  businessAddressList: [] | BusinessAddressListType[];
  bulkUploadHistoryData: BulkUploadHistoryDataType[] | [];
  dispatchResetBulkUploadHistoryData: () => void;
  dispatchResetBusinessAddressList: () => void;
  dispatchResetAllLedgersList: () => void;
  dispatchGetAllBusinessAddressAction: (
    data: GetAllBussinessAddressesListPayloadType
  ) => void;
  dispatchGetAllLedgerListAction: (data: GetAllLedgersListPayloadType) => void;
  allLedgersList: AllLedgersListType[] | [];
}

const RADIO_OPTIONS: RadioTypes[] = [
  {
    id: "0",
    name: "Normal Bulk Upload",
  },
  {
    id: "1",
    name: "Suspense Bulk Upload",
  },
];

type BranchType = {
  value: number | null;
  label: string;
};

type FinalLedgerListType = {
  value: AllLedgersListType;
  label: string;
};

const OTHER_COLUMN_NAMES: any[] = [
  "Document No",
  "Date of Invoice",
  "Narration in Bank",
  "Additional Comments",
  "Transaction Type",
  "Amount",
  "Account No",
  "Branch",
];
const OTHER_SUSPENSE_COLUMN_NAMES: any[] = [
  "Cheque No.",
  "Date",
  "Narration in Bank",
  "Additional Comments",
  "Transaction Type",
  "Amount",
  "Balance",
];

const InvoiceBulkUpload = ({
  history,
  token,
  bulkUploadData,
  success,
  error,
  statusCode,
  fetching,
  dispatchResetSession,
  dispatchResetInvoicingError,
  dispatchResetBulkUploadData,
  dispatchResetInvoicingSuccess,
  dispatchInvoiceBulkUploadAction,
  dispatchInvoiceGenerationSuspenseBulkUploadAction,
  dispatchGetClientColumnListAction,
  mappedRevenueColumnsList,
  dispatchResetMappedRevenueColumnListAction,
  message,
  bulkUploadHistoryCount,
  dispatchInvoiceRevenuesBulkUploadAction,
  dispatchInvoiceExpensesBulkUploadAction,
  dispatchResetMappedExpensesColumnsListAction,
  dispatchGetBulkUploadHistoryData,
  mappedExpensesColumnsList,
  bulkUploadHistoryData,
  businessAddressList,
  dispatchResetBulkUploadHistoryData,
  dispatchResetBulkUploadHistoryCount,
  dispatchGetAllBusinessAddressAction,
  dispatchGetAllLedgerListAction,
  allLedgersList,
  dispatchResetBusinessAddressList,
  dispatchResetAllLedgersList,
}: Props) => {
  const { search, pathname } = useLocation();
  let [type, setType] = useState<string>(
    new URLSearchParams(search).get("type") || pathname.split("=")[1]
  );
  const url = window.location.pathname.split("/");
  const client_code = Number(url[url.length - 1]);

  const [fileData, setFileData] = useState<any>("");
  const [fileNames, setFileNames] = useState([]);
  const findingRoute = useLocation().pathname.split("/");
  const routeName = findingRoute[2];
  const [showToast, setShowToast] = useState(true);
  const [isBulkHistory, setIsBulkHistory] = useState(false);
  const [historyData, setHistoryData] = useState<
    BulkUploadHistoryDataType[] | []
  >([]);
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(20);
  const [radioValue, setRadioValue] = useState(RADIO_OPTIONS[0].id);
  const [branch, setBranch] = useState<BranchType>({
    label: "Select...",
    value: null,
  });
  const [ledger, setLedger] = useState<BranchType>({
    label: "Select...",
    value: null,
  });
  const [branchList, setBranchList] = useState([]);
  const [finalLedgerList, setFinalLedgerList] = useState<
    FinalLedgerListType[] | []
  >([]);
  const [isExpenseBulkUploadHistory, setIsExpenseBulkUploadHistory] =
    useMenuCheck();
  const [isRevenueBulkUploadHistory, setIsRevenueBulkUploadHistory] =
    useMenuCheck();
  const [isOthersBulkUploadHistory, setIsOthersBulkUploadHistory] =
    useMenuCheck();
  const [isSuspenseBulkUpload, setIsSuspenseBulkUpload] = useMenuCheck();

  useEffect(() => {
    setIsExpenseBulkUploadHistory("Expense Bulk Upload History", "menu");
    setIsRevenueBulkUploadHistory("Sales Bulk Upload History", "menu");
    setIsOthersBulkUploadHistory("Others Bulk Upload History", "menu");
    setIsSuspenseBulkUpload("Others Suspense Bulk Upload", "menu");
    dispatchResetInvoicingSuccess();
    dispatchResetInvoicingError();
    dispatchResetBulkUploadData();
    dispatchResetMappedRevenueColumnListAction();
    dispatchResetMappedExpensesColumnsListAction();
    dispatchResetBulkUploadHistoryData();
    dispatchResetBulkUploadHistoryCount();
    dispatchResetBusinessAddressList();
    dispatchResetAllLedgersList();
    if (token && client_code) {
      let finalData = {
        token,
        client_code,
        data_req:"enabled"
      };

      dispatchGetAllLedgerListAction(finalData);
      dispatchGetAllBusinessAddressAction(finalData);
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, []);

  useEffect(() => {
    const option: any = businessAddressList?.map((item: any) => {
      return {
        label: item.trade_name,
        value: item.ledger_number,
      };
    });
    setBranchList(option);
  }, [businessAddressList]);

  useEffect(() => {
    const ledgerList: any = [];
    if (allLedgersList) {
      allLedgersList.map((ledger: AllLedgersListType) => {
        ledgerList.push({
          value: ledger?.ledger_number,
          label: `${ledger?.ledger_name} (${ledger?.ledger_number})`,
        });
      });
    }

    setFinalLedgerList(ledgerList);
  }, [allLedgersList]);

  useEffect(() => {
    setType(new URLSearchParams(search).get("type") || pathname.split("=")[1]);
    if (type === "") {
      setType("othersgeneration");
    }
    /* eslint-disable react-hooks/exhaustive-deps */
  }, [pathname, search]);

  useEffect(() => {
    if (token && offset > 0 && offset < +bulkUploadHistoryCount) {
      let finalData = {
        clientCode: client_code,
        token,
        type,
        limit,
        offset,
      };
      dispatchGetBulkUploadHistoryData(finalData);
    }
  }, [offset]);

  useEffect(() => {
    if (bulkUploadHistoryData?.length === 0) {
      setHistoryData(bulkUploadHistoryData);
    }
    if (offset > 0) {
      setHistoryData((prv: any) => [...prv, ...bulkUploadHistoryData]);
    } else {
      setHistoryData(bulkUploadHistoryData);
    }
  }, [bulkUploadHistoryData]);

  const handleViewHistory = () => {
    if (token) {
      let finalData = {
        clientCode: client_code,
        token,
        type,
        limit,
        offset,
      };
      dispatchGetBulkUploadHistoryData(finalData);
    }
    setIsBulkHistory((prev: boolean) => !prev);
  };

  const mappedColumnList = async () => {
    dispatchResetMappedRevenueColumnListAction();
    dispatchResetMappedExpensesColumnsListAction();

    let finalData: any = {
      token,
      client_code,
    };
    dispatchGetClientColumnListAction(finalData);
  };

  function checkComparison(item: SingleMappedColumnType) {
    return (
      item?.name !== "Bill From Address1" &&
      item?.name !== "Bill From Address2" &&
      item?.name !== "GST Number" &&
      item?.name !== "Customer Address 1" &&
      item?.name !== "Customer Address 2" &&
      item?.name !== "Customer GSTN (if any)" &&
      item?.name !== "Branch Address1" &&
      item?.name !== "Branch Address2" &&
      item?.name !== "Supplier Address 1" &&
      item?.name !== "Supplier Address 2" &&
      item?.name !== "Supplier GSTN (if any)" &&
      item?.name !== "Supplier Address" &&
      item?.name !== "Customer Address" &&
      item?.name !== "Address" &&
      item?.name !== "Ship To Address" &&
      item?.name !== "Ship To GST (if any)" &&
      item?.name !== "File Upload" &&
      item?.name !== "Ship To Name"
    );
  }

  useEffect(() => {
    if (
      message === "Column list has been fetched !" &&
      type?.includes("revenues")
    ) {
      dispatchResetInvoicingSuccess();
      const csvDataPrimary = mappedRevenueColumnsList?.primary?.length
        ? mappedRevenueColumnsList?.primary
            ?.filter((item: SingleMappedColumnType) => {
              if (checkComparison(item)) {
                return item?.name;
              }
            })
            .map((item: SingleMappedColumnType) => {
              return item?.name;
            })
        : [];
      if (csvDataPrimary?.length) {
        csvDataPrimary.unshift("Document Number");
      }
      const csvDataItem = mappedRevenueColumnsList?.item?.length
        ? mappedRevenueColumnsList?.item
            ?.filter((item: SingleMappedColumnType) => {
              if (checkComparison(item)) {
                return item?.name;
              }
            })
            .map((item: SingleMappedColumnType) => {
              return item?.name;
            })
        : [];
      const csvDataPayment = mappedRevenueColumnsList?.payment?.length
        ? mappedRevenueColumnsList?.payment
            ?.filter((item: SingleMappedColumnType) => {
              if (checkComparison(item)) {
                return item?.name;
              }
            })
            .map((item: SingleMappedColumnType) => {
              return item?.name;
            })
        : [];

      const finalCsvData: any = [csvDataPrimary, csvDataItem, csvDataPayment];

      const blob = new Blob([finalCsvData], {
        type: "text/csv;charset=utf-8;",
      });

      FileSaver.saveAs(blob, "template.csv");
    } else if (
      message === "Column list has been fetched !" &&
      type?.includes("expenses")
    ) {
      dispatchResetInvoicingSuccess();
      let csvDataPrimary = mappedExpensesColumnsList?.primary?.length
        ? mappedExpensesColumnsList?.primary
            ?.filter((item: SingleMappedColumnType) => {
              if (checkComparison(item)) {
                return item?.name;
              }
            })
            .map((item: SingleMappedColumnType) => {
              return item?.name;
            })
        : [];

      if (csvDataPrimary?.length) {
        csvDataPrimary.unshift("Document Number");
      }

      const csvDataItem = mappedExpensesColumnsList?.item?.length
        ? mappedExpensesColumnsList?.item
            ?.filter((item: SingleMappedColumnType) => {
              if (checkComparison(item)) {
                return item?.name;
              }
            })
            .map((item: SingleMappedColumnType) => {
              return item?.name;
            })
        : [];

      const csvDataPayment = mappedExpensesColumnsList?.payment?.length
        ? mappedExpensesColumnsList?.payment
            ?.filter((item: SingleMappedColumnType) => {
              if (checkComparison(item)) {
                return item?.name;
              }
            })
            .map((item: SingleMappedColumnType) => {
              return item?.name;
            })
        : [];

      const finalCsvData: any = [csvDataPrimary, csvDataItem, csvDataPayment];

      const blob = new Blob([finalCsvData], {
        type: "text/csv;charset=utf-8;",
      });

      FileSaver.saveAs(blob, "template.csv");
    }
  }, [message]);

  const downloadTemplate = () => {
    setShowToast(false);
    let headList: string[] = [];
    if (type?.includes("revenues") || type?.includes("expenses")) {
      mappedColumnList();
    } else {
      if (radioValue === "1") {
        OTHER_SUSPENSE_COLUMN_NAMES.map((item: any) => {
          headList.push(item);
        });
      } else {
        OTHER_COLUMN_NAMES.map((item: any) => {
          headList.push(item);
        });
      }
      let csvData = headList.toString();
      var blob = new Blob([csvData], {
        type: "text/csv;charset=utf-8;",
      });

      FileSaver.saveAs(blob, "template.csv");
    }
  };

  const handleUpload = (file: any) => {
    setFileData(file);
  };

  const startBulkProcess = () => {
    const params = {
      client_code,
      type: type?.includes("revenues")
        ? "revenues"
        : type?.includes("expenses")
        ? "expenses"
        : type,
      fileData,
      token,
    };
    if (type?.includes("revenues")) {
      dispatchInvoiceRevenuesBulkUploadAction(params);
    } else if (type?.includes("expenses")) {
      dispatchInvoiceExpensesBulkUploadAction(params);
    } else if (radioValue === "1") {
      const params = {
        client_code,
        type: type?.includes("revenues")
          ? "revenues"
          : type?.includes("expenses")
          ? "expenses"
          : type,
        fileData,
        branch: branch?.value,
        account_number: ledger?.value,
        token,
      };
      dispatchInvoiceGenerationSuspenseBulkUploadAction(params);
    } else {
      dispatchInvoiceBulkUploadAction(params);
    }
  };

  const toogleBulkHistoryModal = () => {
    setOffset(0);
    setHistoryData([]);
    dispatchResetBulkUploadHistoryCount();
    dispatchResetBulkUploadHistoryData();
    setIsBulkHistory((prev: boolean) => !prev);
  };

  const handleErrorModal = () => {
    if ((bulkUploadData && bulkUploadData?.success === 0) || success === 0) {
      if (
        (bulkUploadData && bulkUploadData?.status_code === 401) ||
        statusCode === 401
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetInvoicingError();
            }}
            statusCode={statusCode}
          />
        );
      } else if (
        (bulkUploadData && bulkUploadData?.status_code === 204) ||
        (bulkUploadData && bulkUploadData?.status_code === 500) ||
        (bulkUploadData && bulkUploadData?.status_code === 400) ||
        error
      ) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!bulkUploadData?.success}
            title="Error"
            message={
              routeName === "bulk-upload" && bulkUploadData.status_code === 500
                ? "Columns are missing"
                : bulkUploadData?.message || "something went wrong!"
            }
            buttonText="OK"
            onPress={() => {
              dispatchResetBulkUploadData();
              setFileNames([]);
            }}
          />
        );
      }
    }

    if (
      bulkUploadData?.success === 1 &&
      bulkUploadData &&
      bulkUploadData?.message
    ) {
      if (bulkUploadData && bulkUploadData?.error_docs_count === 0) {
        return (
          <ErrorSuccessModal
            type="success"
            isOpen={bulkUploadData?.success === 1}
            title="Success"
            message={
              bulkUploadData?.message || "Document Uploaded Successfully!"
            }
            buttonText="OK"
            onPress={() => {
              dispatchResetBulkUploadData();
              setFileNames([]);
              history.goBack();
            }}
            statusCode={bulkUploadData?.status_code || statusCode}
          />
        );
      } else if (showToast) {
        if (bulkUploadData?.total_inserted_docs === 0) {
          toast.error("Bulk upload unsuccessful!");
        } else {
          toast.success(bulkUploadData?.message);
        }
        setShowToast(false);
      }
    }
    return false;
  };

  const handleChangeBranchName = (item: BranchType) => {
    setBranch({
      label: item?.label,
      value: item?.value,
    });
  };

  const handleLedgerChange = (item: BranchType) => {
    setLedger({
      label: item?.label,
      value: item?.value,
    });
  };

  const handleSetRadioValue = (data: string) => {
    dispatchResetInvoicingSuccess();
    dispatchResetInvoicingError();
    dispatchResetBulkUploadData();
    setRadioValue(data);
    setBranch({
      label: "Select...",
      value: null,
    });
    setLedger({
      label: "Select...",
      value: null,
    });
    setFileNames([]);
  };

  const renderReUpload = () => {
    const {
      total_rows_count,
      error_file,
      total_inserted_docs,
      error_docs_count,
    } = bulkUploadData;
    return (
      <div className="dropzone drop-area" style={{ cursor: "default" }}>
        <h3>
          File Uploaded Successfully{" "}
          {error_docs_count === 0 ? "" : "But Found Errors"}
        </h3>
        <hr />

        <div className="details-card">
          <div>
            <h5>Overview</h5>
            <div className="overview-card">
              <div className="card inside-card">
                <BulkUploadSuccess />
                <h6>
                  <span className="counter-style">{total_inserted_docs}</span>{" "}
                  out of {total_rows_count}{" "}
                </h6>
                <h6 className="counter-sub-header mt-2">Successfull entries</h6>
              </div>
              <div className="card inside-card">
                <BulkUploadError />
                <h6>
                  <span className="counter-style">{error_docs_count}</span> out
                  of {total_rows_count}
                </h6>
                <h6 className="counter-sub-header mt-2">Total errors</h6>
              </div>
            </div>
          </div>

          <div>
            <h5>Please follow the steps below to fix it.</h5>
            <div>
              <div className="card card-text">
                {" "}
                <h5>
                  <span className="card-span">01</span>Please download the file.
                </h5>{" "}
              </div>
              <div className="card card-text">
                <h5>
                  <span className="card-span">02</span>Fix the errors
                </h5>{" "}
              </div>
              <div className="card card-text">
                <h5>
                  <span className="card-span">03</span>Re-upload the file.
                </h5>{" "}
              </div>
            </div>
          </div>
        </div>

        <div className="mt-5 mb-5 d-flex justify-content-end">
          <button
            className="ml-3 btn btn-primary"
            onClick={() => {
              handleReUpload();
              setShowToast(true);
            }}
          >
            Proceed to Re-Upload
          </button>
          <div className="ml-4">
            <a
              href={blobBaseUrl + error_file + "?" + blobToken}
              className={`btn btn-outline-info`}
            >
              Download Error CSV
            </a>
          </div>
        </div>
      </div>
    );
  };

  const handleReUpload = () => {
    dispatchResetBulkUploadData();
    setFileNames([]);
    setFileData("");
    setBranch({
      label: "Select...",
      value: null,
    });
    setLedger({
      label: "Select...",
      value: null,
    });
  };

  return (
    <div className="row">
      <div className="col-md-8 mb-3">
        <CommonHeader
          goBack
          title={`Bulk Upload - ${
            type?.includes("revenues")
              ? "Sales"
              : type?.includes("expenses")
              ? "Expense"
              : "Others"
          }`}
        />
      </div>
      <div className="col-12">
        <div className=" card p-3">
          <div
            className={
              isSuspenseBulkUpload && type === "others"
                ? `header`
                : "d-flex justify-content-end"
            }
            style={{ gap: "5px" }}
          >
            {isSuspenseBulkUpload && type === "others" && (
              <div className="left-header" style={{ marginTop: "-15px" }}>
                <div className="row">
                  <div className="col-md-12">
                    <label htmlFor="work" style={{ fontSize: "12px" }}>
                      Select Upload Type
                    </label>
                    <div className="mt-2">
                      <RadioContainer
                        optionsList={RADIO_OPTIONS}
                        handleSetRadioValue={handleSetRadioValue}
                        radioValue={radioValue}
                      />
                    </div>
                  </div>
                </div>
                {radioValue === "1" && (
                  <div className="mt-3 mb-2">
                    <span>Select Branch and Ledger to map entries</span>
                  </div>
                )}
                {radioValue === "1" && (
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group">
                        <label>
                          Branch <span className="text-danger">*</span>
                        </label>
                        <DropDown
                          placeholder="Choose branch name..."
                          options={branchList}
                          handleChange={handleChangeBranchName}
                          value={branch}
                        />
                        <small className="text-danger">
                          {/* {otherErrors?.branchError} */}
                        </small>
                      </div>
                    </div>
                    <div className="col-md-6">
                      <label>
                        Ledger <span className="text-danger">*</span>
                      </label>
                      <DropDown
                        placeholder="Choose Ledger..."
                        options={finalLedgerList}
                        handleChange={(option) => handleLedgerChange(option)}
                        // components={{ Option }}
                        value={ledger}
                      />
                    </div>
                  </div>
                )}
              </div>
            )}
            <div className="right-header">
              <p className="text-right">
                <button
                  className="btn btn-outline"
                  onClick={() => {
                    setShowToast(false);
                    downloadTemplate();
                  }}
                >
                  <DownloadIcon color="#DD4433" /> Download Blank Template
                </button>
              </p>

              {(type === "expenses" && isExpenseBulkUploadHistory) ||
              (type === "others" && isOthersBulkUploadHistory) ||
              (type === "revenues" && isRevenueBulkUploadHistory) ? (
                <p className="text-right">
                  <button
                    className="btn btn-outline"
                    onClick={() => handleViewHistory()}
                  >
                    <ReloadIcon color="#DD4433" />
                    View History
                  </button>
                </p>
              ) : null}
            </div>
          </div>

          {bulkUploadData && bulkUploadData.error_file ? (
            renderReUpload()
          ) : (
            <DraggableUpload
              handleUpload={handleUpload}
              setFileNames={setFileNames}
              fileNames={fileNames}
              acceptedFileTypes=".csv,text/csv,application/csv"
            />
          )}
          {bulkUploadData && bulkUploadData.error_file ? null : (
            <div className="mt-3 d-flex">
              <button
                className="btn btn-primary btn-lg w-50 m-auto"
                onClick={() => {
                  startBulkProcess();
                  setShowToast(true);
                }}
                disabled={
                  (radioValue === "1" && (!branch?.value || !ledger?.value)) ||
                  !fileData ||
                  !fileNames?.length ||
                  fetching
                    ? true
                    : false
                }
              >
                Proceed
              </button>
            </div>
          )}
        </div>
        {type?.includes("revenues") || type?.includes("expenses") ? (
          <div style={{ width: "100%", paddingTop: "20px" }}>
            <div
              style={{
                backgroundColor: "#fef2ed",
                color: "#ba4916",
                border: "1px solid #ba4916",
                display: "flex",
                alignItems: "start",
                padding: "10px",
              }}
            >
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexDirection: "column",
                  lineHeight: "1.5",
                }}
              >
                <span style={{ fontSize: "16px" }}>Instructions</span>
                <span>
                  1. Make sure the date format should be "DD-MM-YYYY".
                </span>
                <span>
                  2. Bulk upload only accepts 2-digit values after decimal.
                </span>
                <span>
                  3. Value of Amount, Discount, Taxable value, GST %, IGST,
                  CGST, SGST, and Total value should be according to the correct
                  calculation.
                </span>
                <span>
                  {type?.includes("revenues")
                    ? "4. Bulk upload accepts only the Ledger number/ Unique Number / SKU Number for the Bill Form, Customer, Nature of Income, SKU, and Mode of Receipt columns."
                    : "4. Bulk upload accepts only the Ledger number/ Unique Number / SKU Number for the Branch, Supplier, Nature of Expense, SKU, and Mode of Payment columns."}
                </span>
                <span>
                  {type?.includes("revenues")
                    ? "5. Net Amount Received, Mode of Receipt, and Date of Receipt all are mandatory fields for payment."
                    : "5. Net Payment Made, Mode of Payment, and Date of Payment all are mandatory fields for payment."}
                </span>
                <span>
                  6. Bulk upload not accept different primary data with the same
                  document number.
                </span>
                <span>
                  7. There should be at least one item for bulk upload.
                </span>
                <span>
                  8. Rate & Quantity should be mandatory for SKU based entry.
                </span>
                <span>
                  9. Document number & primary data should be same for multiple
                  items and payments as well.
                </span>
                <span>
                  10. Multi Currency and Shipping address are not available in
                  bulk upload.
                </span>
                <span>
                  11. In case of failed bulk upload, download the error report
                  and rectify the mistakes. After this, please make sure the
                  format of the columns containing
                </span>
                <span style={{ marginLeft: "19px", marginTop: "-5px" }}>
                  {" "}
                  numbers with more than 12 digits is changed to "Number Format"
                  before saving the rectified report.
                </span>
              </div>
            </div>
          </div>
        ) : (
          ""
        )}

        {isBulkHistory ? (
          <div>
            <BulkUploadHistoryModal
              isBulkHistory={isBulkHistory}
              toogleBulkHistoryModal={toogleBulkHistoryModal}
              historyData={historyData}
              fetching={fetching}
              offset={offset}
              setOffset={setOffset}
              limit={limit}
            />
          </div>
        ) : null}

        {fetching && offset === 0 ? <Loader /> : null}
        {handleErrorModal()}
        <Toaster />
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  bulkUploadData: state.invoiceGeneration.bulkUploadData,
  token: state.auth.token,
  fetching: state.invoiceGeneration.fetching,
  success: state.invoiceGeneration.success,
  message: state.invoiceGeneration.message,
  error: state.invoiceGeneration.error,
  statusCode: state.invoiceGeneration.statusCode,
  mappedRevenueColumnsList: state.invoiceGeneration.mappedRevenueColumnsList,
  mappedExpensesColumnsList: state.invoiceGeneration.mappedExpensesColumnsList,
  bulkUploadHistoryData: state.invoiceGeneration.bulkUploadHistoryData,
  bulkUploadHistoryCount: state.invoiceGeneration.bulkUploadCount,
  businessAddressList: state.clientSettings.businessAddressList,
  allLedgersList: state.clientSettings.allTypesLedgersWithTaxList,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetBulkUploadData: () => dispatch(resetBulkUploadData()),
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetInvoiceStatusCode: () => dispatch(resetInvoiceStatusCode()),
  dispatchResetInvoicingError: () => dispatch(resetInvoicingError()),
  dispatchResetInvoicingSuccess: () => dispatch(resetInvoicingSuccess()),
  dispatchInvoiceBulkUploadAction: (params: any) =>
    dispatch(invoiceGenerationBulkUploadAction(params)),
  dispatchInvoiceGenerationSuspenseBulkUploadAction: (params: any) =>
    dispatch(invoiceGenerationSuspenseBulkUploadAction(params)),
  dispatchInvoiceRevenuesBulkUploadAction: (params: any) =>
    dispatch(invoiceGenerationRevenuesBulkUploadAction(params)),
  dispatchInvoiceExpensesBulkUploadAction: (params: any) =>
    dispatch(invoiceGenerationExpensesBulkUploadAction(params)),
  dispatchGetClientColumnListAction: (data: any) =>
    dispatch(getAllMappedClientColumnListAction(data)),
  dispatchResetMappedRevenueColumnListAction: () =>
    dispatch(resetMappedRevenueColumnList()),
  dispatchResetMappedExpensesColumnsListAction: () =>
    dispatch(resetMappedExpensesColumnList()),
  dispatchGetBulkUploadHistoryData: (data: GetBulkUploadHistoryPayloadType) =>
    dispatch(getBulkUploadHistoryAction(data)),
  dispatchResetBulkUploadHistoryData: () =>
    dispatch(resetBulkUploadHistoryData()),
  dispatchResetBulkUploadHistoryCount: () =>
    dispatch(resetBulkUploadHistoryCount()),
  dispatchResetBusinessAddressList: () => dispatch(resetBusinessAddressList()),
  dispatchResetAllLedgersList: () => dispatch(resetAllLedgersList()),
  dispatchGetAllBusinessAddressAction: (
    data: GetAllBussinessAddressesListPayloadType
  ) => dispatch(getAllBusinessAddressAction(data)),
  dispatchGetAllLedgerListAction: (data: GetAllLedgersListPayloadType) =>
    dispatch(getAllTypesWithTaxListAction(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(InvoiceBulkUpload);
